import { insertIntoArray } from '../utils';
import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const escrowOfficerCard = buildAdditionalContactCard({
  contactType: 'escrowOfficer',
  contactLabel: 'Escrow',
  overrides: {
    hideByDefault: false,
    displayFields: (displayFields) => [
      {
        name: 'contacts.escrowOfficer.x.escrowNumber',
        type: 'default',
      },
      ...displayFields,
    ],
    layout: (defaultLayout) =>
      insertIntoArray(defaultLayout, 1, [
        {
          name: 'contacts.escrowOfficer.x.escrowNumber',
          size: 100,
        },
      ]),
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Escrow Officer, Assistant, etc',
      },
      escrowNumber: {
        name: 'contacts.escrowOfficer.x.escrowNumber',
        entity: 'contacts',
        entityType: 'escrowOfficer',
        type: 'text',
        label: 'Escrow Number',
        placeholderText: '',
      },
    },
  } satisfies ContactCardOverrides,
});
